import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-file-widget',
  templateUrl: './sf-file-widget.component.html'
})
export class FileWidgetComponent extends ControlWidget {

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/file/sf-file-widget.component.ts